import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UtilitiesService } from 'src/app/services/utilities.service';
@Component({
    selector: 'app-generic-prompt',
    templateUrl: './generic-prompt.component.html',
    styleUrls: ['./generic-prompt.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericPromptComponent implements OnInit {
    @Input() okHandlerFn: () => Promise<void>;
    @Input() dismissFn: () => void;
    @Input() messages: { mainMessage: string, title: string, successMessage: string, unexpectedErrorMessage: string};
    @ViewChild('input', { static: true }) private input: ElementRef<HTMLElement>;
    public saving$ = new BehaviorSubject(false);
    constructor(
        private utilities:UtilitiesService,
    ) { }

    ngOnInit() {
        this.input?.nativeElement.focus();
    }

    public async okayHandler() {
        try{
            console.log('saving 1');
            this.saving$.next(true);
            console.log('saving 2');
            console.log(this);
            await this.okHandlerFn();
            this.utilities.notifySuccess(this.messages.successMessage);
        }
        catch(err){
            if(err.details){
                this.utilities.notifyError(err.details);
                return;
            }
            this.utilities.notifyError(this.messages.unexpectedErrorMessage);
        }
        finally{
            this.saving$.next(false);
            this.dismissFn();
        }
    }

    public cancelHandler() {
        this.dismissFn();
    }

}
